import { Type } from "class-transformer";
import { ILocation, Location } from "@harlowe/core"


export interface IAddress
{
    id:number;
    addressType: number;
    location: ILocation;
}

export class Address implements IAddress
{
    constructor
    (
        public id: number,
        public addressType: number,
        location: Location
    )
    {
        this.location = location;
    }

    @Type(() => Location)
    location: Location;
}

export class AddressInsert
{
    constructor
    (
        address: IAddress
    )
    {
        this.addressType = address.addressType;
        this.street1 = address.location.street1;
        this.street2 = address.location.street2;
        this.city = address.location.city;
        this.state = address.location.state;
        this.zipCode = address.location.zipCode;

    }
    addressType: number;
    street1: string;
    city: string;
    state: string;
    zipCode: string;
    street2?: string;
}

export class AddressUpdate
{
    constructor
    (
        public id: number,
        public addressType?: number,
        public street1?: string,
        public street2?: string,
        public city?: string,
        public state?: string,
        public zipCode?: string
   
    )
    {}
}